/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as a from "react";
import { classNames as l } from "@progress/kendo-react-common";
class i extends a.Component {
  constructor() {
    super(...arguments), this.handleClick = (e) => {
      const { onClick: s, firstDate: r, weekDays: t } = this.props;
      s && e && s.call(void 0, r, t || [], e);
    };
  }
  render() {
    const { className: e, firstDate: s, weekDays: r, ...t } = this.props;
    return /* @__PURE__ */ a.createElement("td", { className: l("k-calendar-td", e), ...t, onClick: this.handleClick }, this.props.children);
  }
}
export {
  i as CalendarWeekCell
};
